import { TicketClassCategory } from '../../constants';
import { AVAILABLE_TICKET_STATUS } from '../../containers/ticketSelection/constants';
import { Ticket } from '../../models/tickets';
import { CheckoutState } from '../../state';
import { getTicketsById } from './pureSelectors';

export const getHasAddonsTicketsAvailable = (state: CheckoutState) => {
    return !!Object.values<Ticket>(getTicketsById(state)).find(
        ({ category, onSaleStatus }) =>
            category === TicketClassCategory.addOn &&
            onSaleStatus === AVAILABLE_TICKET_STATUS,
    );
};
